import createRoute        from '@widesk-ui/tools/createRoute';
import ScheduleGroupModel from '@models/shop/ScheduleGroupModel';

export default createRoute.dashboard('/schedule_groups', 'shop', 'ScheduleGroupDashboard', ScheduleGroupModel.localize());
